import StatsigTracking from 'chimera/all/plugins/tracking/statsig'
import Vue from 'vue'
import { EventBus } from 'chimera/all/plugins/eventbus'

export default ({ env, store }) => {
  if (!env.statsigClientKey) {
    // eslint-disable-next-line no-console
    EventBus.emitWarningAppErrorEvent(
      new Error('Statsig client key is missing'),
      { context: 'statsig/install' },
    )

    // Emit ready event so antiflicker doesn't block
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('experimentation:ready'))
    }
    return
  }

  const options = {
    clientKey: env.statsigClientKey,
    visitorId: store.getters['context/get']('visitorId'),
    sessionId: store.getters['context/get']('sessionId'),
    environment: env.environment,
    deviceType: store.getters['context/get']('deviceType'),
    country: store.getters['context/get']('country'),
    language: store.getters['context/get']('language'),
    label: env.concept,
  }

  Vue.use(StatsigTracking, options)
}
